import React, { Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingIndicatorComponent from "../utils/loadingIndicator";
import axios from 'axios';

class AppointmentListComponent extends Component {

    state = {
        appointments : null,
        dataRequestSent: false,
    };

    componentDidMount() {
        this.getAppointmentList();
    }

    getAppointmentList = () => {
        let parametriPretrage = {
            telefon: this.props.userPhone,
            email: this.props.userEmail
        };
        if(!this.state.dataRequestSent){
            this.state.dataRequestSent = true;
            axios.post("/api/list_bookings/", parametriPretrage)
            .then(response => {

                let mojeRezervacije = response.data.events;
                for (let i = 0; i < mojeRezervacije.length; i++) {
                    mojeRezervacije[i]["datum"] = this.timestampToDateString(mojeRezervacije[i]["start"]);
                }
                this.setState({appointments: mojeRezervacije});
            });
        }
    }

    getTabularData = () => {
        if(this.state.appointments.length>0){
            return <table className="table">
            <thead>
                <tr>
                <th scope="col">Opis</th>
                <th scope="col">Frizer</th>
                <th scope="col">Vreme</th>
                <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                {this.state.appointments.map(appointment => 
                    <tr key={appointment.id}>
                    <td style={{textAlign:"left"}}>{appointment.summary}</td>
                    <td style={{textAlign:"left"}}>{appointment.barber}</td>
                    <td style={{textAlign:"left"}}>{appointment.datum}</td>
                    <td><div className="btn btn-xs btn-primary" onClick={() => this.props.onAppointmentCancellationTry(appointment.id)}><i className="fa fa-trash" aria-hidden="true"></i>&nbsp;Otkaži</div></td>
                    </tr>
                    )}
                
            </tbody>
            </table>
        }
        else{
            return <p className="big"> Nema zakazanih termina za uneseni broj telefona i e-mail.</p>
        }
    }

    timestampToDateString = function(timestamp) {
        var date = new Date(+timestamp*1000);
        var dan = date.getDate();
        var mesec = date.getMonth()+1;
        var godina = date.getFullYear();
        var sat = date.getHours();
        var minut = date.getMinutes();
    
        return dan+"."+mesec+"."+godina+" u "+sat+"."+(minut<=9? "0"+minut: minut )+"h";
      };

    // otkaziRezervaciju = (id) => {
        
    //     var call = "/api/cancel_booking/";
    //     axios.post(call, { "id": id, "data": this.props.userInformation })
    //         .then(response => {
    //             this.state.appointments = response.data.events;
    //             for (let i = 0; i < this.state.appointments.length; i++) {
    //                 this.state.appointments[i]["datum"] = this.timestampToDateString(this.state.appointments[i]["start"]);
    //             }
    //             this.setState({appointments: response.data.events});
    //             toast.success("Uspešno ste otkazali svoj termin!")           
    //         });
    //   };
  

    render() { 
        if (!this.state.appointments) {
            return <LoadingIndicatorComponent/>
        }

        return (  
            <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
                <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                />
                <div className="shell">
                    <h2>Moje rezervacije</h2>
                    <div className="p text-width-medium">
                    <p className="big"></p>
                    </div>
                    {this.getTabularData()}
                    <a className="btn btn-sm btn-style-1 btn-white-pickled-bluewood" href="/">Nazad na početnu stranicu</a>
                </div>
                </section>
      );
    }
}
 
export default AppointmentListComponent;